/// <reference types="vite/client" />

type GeneratedConfig = {
  apiUrl?: string;
  cognitoRegion?: string;
  cognitoUserPool?: string;
  cognitoClientId?: string;
  cognitoDomain?: string;
  environment?: string;
};

const generatedConfigModules = import.meta.glob<{ default: GeneratedConfig }>(
  "./config.generated.json",
  { eager: true },
);

const generated =
  generatedConfigModules["./config.generated.json"]?.default ?? {};

export const config = {
  api: {
    baseUrl:
      import.meta.env.VITE_API_URL ||
      generated.apiUrl ||
      "http://localhost:3000",
  },

  cognito: {
    region:
      import.meta.env.VITE_COGNITO_REGION ||
      generated.cognitoRegion ||
      "eu-central-1",
    userPoolId:
      import.meta.env.VITE_COGNITO_USER_POOL_ID ||
      generated.cognitoUserPool ||
      "",
    clientId:
      import.meta.env.VITE_COGNITO_CLIENT_ID || generated.cognitoClientId || "",
    domain:
      import.meta.env.VITE_COGNITO_DOMAIN || generated.cognitoDomain || "",
  },

  environment:
    import.meta.env.VITE_ENVIRONMENT || generated.environment || "development",
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

if (config.isDevelopment) {
}
